import { FC, useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { AdminHeader } from "@/pages/ManagerView/AdminHeader";
import { useNavigate } from "react-router-dom";
import { AnnouncementsListGrid } from "./AnnouncementsListGrid";

const useStyles = makeStyles()((theme) => ({
	adminAnnouncementsList: {
		"& svg path": {
			fill: theme.palette.common.white,
		},
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase",
		},
	},
}));

/**
 * Admin Announcements List (App2).
 * Uses React Query and DataGridPro; no useApi/hitApi.
 */
export const AdminAnnouncementsList: FC = () => {
	const { classes } = useStyles();
	const navigate = useNavigate();

	const onCreateClick = useCallback(() => {
		navigate("create");
	}, [navigate]);

	return (
		<Box className={classes.adminAnnouncementsList}>
			<AdminHeader
				title="Announcements"
				subtitle="Create and send messages to your company employees"
				actionButtons={[{ label: "Create New", onClick: onCreateClick }]}
			/>
			<AnnouncementsListGrid />
		</Box>
	);
};
